export const userProfileData = [
  {
    field: "Name:",
    fieldValue: "Michael Hunter",
    stackDirection: "row",
    alignPosition: "center",
    color: "text.secondary",
    variant: "subtitle1",
    valueVariant: "subtitle2",
  },
  {
    field: "Location:",
    fieldValue: "Bowie, Md",
    stackDirection: "row",
    alignPosition: "center",
    color: "text.secondary",
    variant: "subtitle1",
    valueVariant: "subtitle2",
  },
  {
    field: "Nationality",
    fieldValue: "American",

    stackDirection: "row",
    alignPosition: "center",
    color: "text.secondary",
    variant: "subtitle1",
    valueVariant: "subtitle2",
  },
  {
    field: "Skills",
    fieldValue: "React, Express, Node.js, MongoDb, TypeScript",
    stackDirection: "row",
    alignPosition: "center",
    color: "text.secondary",
    variant: "subtitle1",
    valueVariant: "subtitle2",
  },
];
